

const nodeTypeMap: any =  {};
for (let i = 0; i < 30; i++) {
    nodeTypeMap[i] = [];
}

class pvLocation {
    public raw: any;
    public lastLoadDate: Map<String, Date> = new Map<String, Date>();
    public nodes: any = nodeTypeMap;
    public type: string;

    constructor(location: Record<any, any>, type: string, nodes: {}) {
        this.raw = location;
        this.type = type;

        if (nodes && Object.keys(nodes).length > 0) {
            console.log('oh, nodes! ', nodes);
            this.nodes = nodes;
            Object.keys(this.nodes).forEach((type: any) => {
                let typedNodes = this.nodes[type];
                typedNodes.forEach((node: any) => node.selected = false);
            })
        }
    }

    public get title() { return this.raw.title };
    public get id() { return this.raw.id };
}

export default pvLocation;